import type { ReactNode } from "react";
import OestraIcon from "@/icons/products/product-oestra-r.svg";
import OestraColoredLabelIcon from "@/icons/products/product-oestra-r-colored-label.svg";

export type HormoneSupportOestraMobileContent = {
    image: string;
    imageAlt: string;
    badge: ReactNode;
    description: ReactNode;
    bullets: string[];
    showGradientOverlay: boolean;
};

export type HormoneSupportOestraDesktopContent = {
    backgroundImage: string;
    badge: ReactNode;
    description: ReactNode;
    bullets: string[];
};

export type HormoneSupportOtherContent = {
    mobileImage: string;
    desktopImage: string;
    imageAlt: string;
    heading: string;
    description: ReactNode;
    bullets: string[];
};

export type HormoneSupportComparisonContent = {
    oestraMobile: HormoneSupportOestraMobileContent;
    oestraDesktop: HormoneSupportOestraDesktopContent;
    other: HormoneSupportOtherContent;
};

const OESTRA_BULLETS = ["One formula.", "One routine.", "One price."];

const OTHER_BULLETS = [
    "Estrogen patch",
    "Progesterone pill",
    "Vaginal cream",
    "Sometimes testosterone",
];

const OESTRA_MOBILE_IMAGE_DEFAULT =
    "https://res.cloudinary.com/dirscuuhp/image/upload/v1774870930/new_design/Frame_2087329497_kgvptp.webp";

const OESTRA_MOBILE_IMAGE_HRT =
    "https://res.cloudinary.com/dirscuuhp/image/upload/v1775637074/new_design/Frame_2087329548_1_eque6l.webp";

const oestraMobileDescription = (
    <>
        Oestra<sup>®</sup> replaces the patchwork with one steady formula designed for systemic absorption and balanced dosing.
    </>
);

const oestraDesktopDescription = (
    <>
        Oestra<sup>®</sup> replaces the patchwork with <br />
        one steady formula designed for <br />
        <span className="italic text-[23px] font-featureDisplay font-normal">
            systemic
        </span>{" "}
        absorption and{" "}
        <span className="italic text-[23px] font-featureDisplay font-normal">
            balanced
        </span>{" "}
        dosing.
    </>
);

const otherDescription = (
    <>
        Most hormone therapy <br />ends up looking like this:
    </>
);

const baseContent: HormoneSupportComparisonContent = {
    oestraMobile: {
        image: OESTRA_MOBILE_IMAGE_DEFAULT,
        imageAlt: "Oestra cream",
        badge: <OestraIcon className="w-[193px] h-auto mx-auto" />,
        description: oestraMobileDescription,
        bullets: OESTRA_BULLETS,
        showGradientOverlay: true,
    },
    oestraDesktop: {
        backgroundImage:
            "https://res.cloudinary.com/dirscuuhp/images/f_auto,q_auto/v1776262552/oestra-bg/oestra-bg.webp",
        badge: <OestraIcon className="mx-auto mb-5 h-auto w-[193px]" />,
        description: oestraDesktopDescription,
        bullets: OESTRA_BULLETS,
    },
    other: {
        mobileImage:
            "https://res.cloudinary.com/dirscuuhp/image/upload/v1774871973/new_design/Frame_2087329498_1_iissfs.webp",
        desktopImage:
            "https://res.cloudinary.com/dirscuuhp/image/upload/v1778163327/new_design/Oestra_Magnific_Precision_Upscale_V2_2026-02-28_19-12-33_1_uha6lc.webp",
        imageAlt: "Other methods",
        heading: "The Other Methods",
        description: otherDescription,
        bullets: OTHER_BULLETS,
    },
};

export const hrt3HormoneSupportContent: HormoneSupportComparisonContent = baseContent;

export const hrtHormoneSupportContent: HormoneSupportComparisonContent = {
    ...baseContent,
    oestraMobile: {
        ...baseContent.oestraMobile,
        image: OESTRA_MOBILE_IMAGE_HRT,
        badge: <OestraColoredLabelIcon className="w-[193px] h-auto mx-auto" />,
        showGradientOverlay: false,
    },
};
